import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import moment from 'moment';

var formatString = function formatString(endText, format) {
  if (typeof format === 'function') {
    return format(moment(endText));
  }

  return moment(endText).format(format);
};
/**
 * 格式化区域日期
 *
 * @param value
 */


var dateArrayFormatter = function dateArrayFormatter(value, format) {
  var _ref = Array.isArray(value) ? value : [],
      _ref2 = _slicedToArray(_ref, 2),
      startText = _ref2[0],
      endText = _ref2[1];

  var formatFirst;
  var formatEnd;

  if (Array.isArray(format)) {
    formatFirst = format[0];
    formatEnd = format[1];
  } else {
    formatFirst = format;
    formatEnd = format;
  } // activePickerIndex for https://github.com/ant-design/ant-design/issues/22158


  var parsedStartText = startText ? formatString(startText, formatFirst) : '';
  var parsedEndText = endText ? formatString(endText, formatEnd) : '';
  var valueStr = parsedStartText && parsedEndText ? "".concat(parsedStartText, " ~ ").concat(parsedEndText) : '';
  return valueStr;
};

export default dateArrayFormatter;